import { render, staticRenderFns } from "./yzqmx.vue?vue&type=template&id=bd282744&scoped=true&"
import script from "./yzqmx.vue?vue&type=script&lang=js&"
export * from "./yzqmx.vue?vue&type=script&lang=js&"
import style0 from "./yzqmx.vue?vue&type=style&index=0&id=bd282744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd282744",
  null
  
)

export default component.exports